<template>

  <vs-select v-model="selectedHour" width="55px" @change="handleChange">
    <vs-select-item v-for="(item, index) in options" :key="index" :value="item.value" :text="item.text" />
  </vs-select>

</template>

<script>
import * as _ from "lodash";

export default {
  props: {
    value: {
      type: Number,
      validator: (value) => {
        return _.isInteger(value) && value >= 0 && value <= 23;
      },
      default: 0,
    },
    fromHour: {
      type: Number,
      validator: (value) => {
        return _.isInteger(value) && value >= 0 && value <= 23;
      },
      default: 0,
    },
    toHour: {
      type: Number,
      validator: (value) => {
        return _.isInteger(value) && value >= 0 && value <= 23;
      },
      default: 23,
    },
  },
  data() {
    return {
      options: [],
      selectedHourItem: undefined,
    };
  },
  computed: {
    selectedHour: {
      get() {
        return this.selectedHourItem ? this.selectedHourItem.value : undefined;
      },
      set(value) {
        this.selectedHourItem = this.options.find(item => item.value === value);
      }
    }
  },
  mounted() {
    this.createOptions();
  },
  beforeUpdate() {
    if(!this.selectedHourItem) this.selectedHourItem = this.options.find(item => item.value === this.value);
  },
  methods: {
    createOptions() {
      for(let i = this.fromHour; i<=this.toHour; i++) {
        this.options.push({
          value: i,
          text: _.padStart(i, 2, '0')
        });
      }
    },
    handleChange(value) {
      this.$emit('input', value);
    }
  },
};
</script>

<style scoped>
.test {
  width:50px;
}
</style>
